interface DealerLocatorOptionsProps {
  children: React.JSX.Element | React.JSX.Element[];
}

export const DealerLocatorToggleButtons = ({
  children
}: DealerLocatorOptionsProps) => (
  <div className="d-flex flex-column row-gap-3">{children}</div>
);
